import React from 'react';

import i18next from 'i18next';
import { useParams } from 'react-router-dom';

import { Permissions } from 'src/app_deprecated/constants/PermissionsConstants';

import { Heading } from 'src/app/components/lib/heading';
import { PageVariant } from 'src/app/components/lib/page';
import TabPage from 'src/app/layout/main/tab-page';
import { usePermissionCheck } from 'src/app/state/user-permissions';

import { MarketingTags } from './marketing-tags';
import Templates from './marketing-templates';

import type { TabLink } from 'src/app/layout/main/tab-page';

function MarketingConfigure() {
  const { '*': paramString } = useParams();
  const hasViewTemplatesPermission = usePermissionCheck(
    [Permissions.ViewEmailTemplates, Permissions.CreateEditEmailTemplates],
    'or'
  );

  const hasViewMarketingTagsPermission = usePermissionCheck(
    [Permissions.ViewCampaigns, Permissions.AccessEmailMarketing],
    'or'
  );

  const header = <Heading>{i18next.t('Configure')}</Heading>;

  const tabs: TabLink[] = [
    {
      label: 'Templates',
      to: `templates`,
      hasPermission: hasViewTemplatesPermission ?? false,
      element: <Templates />,
      hasNestedRoutes: true,
    },
    {
      label: 'Tags',
      to: 'tags',
      hasPermission: hasViewMarketingTagsPermission ?? false,
      element: <MarketingTags />,
      hasNestedRoutes: true,
    },
  ];

  const tablePages = ['tags', 'templates'];

  const isTablePage = tablePages.includes(paramString ?? '');

  return <TabPage header={header} tabs={tabs} variant={isTablePage ? PageVariant.Table : undefined} />;
}

export default MarketingConfigure;
